import axios from "axios";
import { showToast } from "../data/redux/slices/ToastSlice";
import { store } from "../data/redux/store";
import { openUpgradeModal } from "../data/redux/slices/UpgradePlanModalSlice";

const baseURL =
  process.env.NODE_ENV === "production"
    ? "https://16za49tm71.execute-api.eu-north-1.amazonaws.com/"
    : "http://localhost:3003/";

const api = axios.create({ baseURL });

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { action, message } = error.response?.data || {};

    if (action === "Upgrade Plan") {
      store.dispatch(openUpgradeModal(message));
    }

    return Promise.reject(error);
  }
);


export default api;
